import React, { FC } from 'react';

import styles from '../PolicyStatus/styles.module.css';
import classNames from 'classnames';
import { Pill, Button } from '@clearcover/atlas';
import { useHistory, useParams } from 'react-router-dom';

export const PendingDraft: FC<{
  id: string;
  type:
    | 'full_term'
    | 'mid_term'
    | 'cancellation'
    | 'reinstatement'
    | 'renewal'
    | 'renewal_quote';
  effectivePeriod: {
    startAt: string;
    endAt: string;
  };
}> = ({ id, type }) => {
  const history = useHistory();
  const { id: policyId } = useParams<{ id: string }>();

  if (!['renewal_quote', 'mid_term'].includes(type)) return null;

  const text =
    type === 'renewal_quote'
      ? {
          banner:
            'There is an existing quote draft for this renewal term. Click finalize quote to continue.',
          button: 'Finalize quote',
        }
      : {
          banner:
            'There is an existing draft for this policy. Click finalize draft to continue.',
          button: 'Finalize draft',
        };

  return (
    <div
      className={classNames(styles.subStatus, styles.draft)}
      data-testid={'pending-draft'}
    >
      <Pill variant={'draft'} className={styles.subStatusPill}>
        Draft
      </Pill>
      <span>{text.banner}</span>
      <Button
        data-testid={'open-draft-button'}
        className={styles.subStatusButton}
        variant="secondary"
        size="sm"
        onClick={() => {
          history.push(`/policies/${policyId}/draft/${id}`);
        }}
      >
        {text.button}
      </Button>
    </div>
  );
};
